import { Box, Button, Group, Heading, Text } from '@optiaxiom/react';
import { IconCubes, IconPlus } from '@optiaxiom/icons';
import styles from './AppsPage.module.css';

interface AppsEmptyStateProps {
  onRegister: () => void;
}

/** Shown when the developer (and their vendor) own no apps yet. */
export function AppsEmptyState({ onRegister }: AppsEmptyStateProps) {
  return (
    <Group alignItems="center" flexDirection="column" className={styles.stateContainer}>
      <Box className={styles.iconTile}>
        <IconCubes size={30} />
      </Box>
      <Heading level="2" fontWeight="700" className={styles.stateTitle}>
        No apps yet
      </Heading>
      <Text color="fg.secondary" className={styles.stateBody}>
        Apps you or your vendor own will show up here. Create your first app with the OCP CLI to get
        started.
      </Text>
      <Button appearance="primary" size="lg" addonBefore={<IconPlus />} onClick={onRegister}>
        Register app
      </Button>
    </Group>
  );
}
